/**
 * This file is auto-generated from app.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const title: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Consult a doctor';
        case 'pl':
            return 'Twój lekarz zaraz Cię przyjmie';
    }
};

export const description: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Consult a doctor online. Get medical advice and treatment from licensed physicians through our easy-to-use platform.';
        case 'pl':
            return 'Skonsultuj się z lekarzem online. Uzyskaj poradę medyczną i leczenie od licencjonowanych lekarzy za pośrednictwem naszej łatwej w użyciu platformy.';
    }
};
